/* AUTO-GENERATED by scripts/sync-vision-runtime-parameters.mjs. DO NOT EDIT BY HAND. */
export const VISION_RUNTIME_PARAMETER_CATALOG_VERSION = "vision-runtime-parameters-v2-deep-tunable-gates" as const;
export const VISION_RUNTIME_PARAMETER_CATALOG_SHA256 = "a2b1f799547c067ed14bc7d693be35cc815010b3264cb9ffb7ef977b1932e434" as const;
export const DETECTION_RUNTIME_DEFAULTS = {
  "GRID_MASTER_SCORE": 0.6,
  "GRID_COMBINE_SCORE": 0.45,
  "MIN_ORB_INLIERS_ABSOLUTE": 6,
  "MIN_CONFIDENCE_REFINEMENT": 6,
  "MIN_CONFIDENCE_RECOVERY": 4,
  "MAX_REPROJECTION_ERROR_REFINEMENT": 2.5,
  "MAX_REPROJECTION_ERROR_RECOVERY": 4,
  "MAX_RELATIVE_CORNER_SHIFT": 0.08,
  "MIN_LABEL_AREA_RATIO": 0.1,
  "MAX_LABEL_AREA_RATIO": 0.55,
  "EXPECTED_ASPECT_RATIO": 4.35,
  "ASPECT_TOLERANCE": 0.7,
  "STRUCTURE_MIN_AREA_RATIO": 0.1,
  "STRUCTURE_MAX_AREA_RATIO": 0.55,
  "SUBPIX_WINDOW_RADIUS": 5,
  "SUBPIX_MAX_SHIFT_PX": 8,
  "SUBPIX_MIN_GRADIENT": 12,
  "HYBRID_REFERENCE_WEIGHT": 0.42,
  "HYBRID_GEOMETRY_WEIGHT": 0.23,
  "HYBRID_CNN_WEIGHT": 0.18,
  "HYBRID_OPENCV_WEIGHT": 0.12,
  "GRID_RECONSTRUCTION_MIN_HORIZONTAL_MATCHES": 3,
  "GRID_RECONSTRUCTION_MIN_VERTICAL_MATCHES": 2,
  "GRID_RECONSTRUCTION_MAX_AXIS_RESIDUAL": 0.036,
  "GRID_RECONSTRUCTION_MIN_SCORE": 0.42,
  "FINAL_SUPPORT_MIN_HORIZONTAL_LINES": 3,
  "FINAL_SUPPORT_MIN_VERTICAL_LINES": 2,
  "FINAL_SUPPORT_MIN_LINE_RATIO": 0.16,
  "FINAL_SUPPORT_NEIGHBOR_RADIUS": 2,
  "ORB_FEATURES": 2200,
  "ORB_SCALE_FACTOR": 1.2,
  "ORB_LEVELS": 8,
  "ORB_EDGE_THRESHOLD": 31,
  "ORB_PATCH_SIZE": 31,
  "ORB_FAST_THRESHOLD": 10,
  "ORB_KNN_RATIO": 0.78,
  "ORB_FALLBACK_DISTANCE_FACTOR": 0.72,
  "ORB_FALLBACK_DISTANCE_MIN": 28,
  "ORB_FALLBACK_DISTANCE_MAX": 72,
  "ORB_RANSAC_THRESHOLD": 4,
  "GRID_RANSAC_THRESHOLD": 3,
  "ORB_MIN_GOOD_MATCHES": 8,
  "ORB_GEOMETRIC_TOLERANCE_MIN": 42,
  "ORB_GEOMETRIC_TOLERANCE_FACTOR": 0.085,
  "ORB_SPATIAL_MAX_MATCHES_PER_CELL": 28,
  "ORB_SPATIAL_MAX_MATCHES_TOTAL": 260,
  "ORB_REFINEMENT_MIN_SCORE": 0.3,
  "ORB_REFINEMENT_MIN_INLIER_RATIO": 0.28,
  "ORB_MASTER_MAX_CORNER_SHIFT_RATIO": 0.055,
  "ORB_COMBINE_MAX_CORNER_SHIFT_RATIO": 0.11,
  "CLAHE_CLIP_LIMIT": 2.2,
  "CLAHE_TILE_GRID": 8,
  "HYBRID_MIN_GEOMETRY_QUALITY": 0.42,
  "HYBRID_TARGET_MIN_CONFIDENCE": 0.45,
  "HYBRID_TARGET_MAX_CORNER_DISTANCE_RATIO": 0.18,
  "HYBRID_REFERENCE_MIN_HORIZONTAL_LINES": 2,
  "HYBRID_REFERENCE_MIN_VERTICAL_LINES": 2,
  "HYBRID_REFERENCE_MIN_AVERAGE_SUPPORT": 0.12,
  "HYBRID_CANDIDATE_ACCEPT_BONUS": 0.05,
  "HYBRID_RELAXED_MIN_AREA_FLOOR": 0.055,
  "HYBRID_RELAXED_MIN_AREA_FACTOR": 0.55,
  "HYBRID_RELAXED_MAX_AREA_CEILING": 0.72,
  "HYBRID_RELAXED_MAX_AREA_FACTOR": 1.3,
  "HYBRID_RELAXED_MIN_ASPECT_RATIO": 2.65,
  "HYBRID_RELAXED_MAX_ASPECT_RATIO": 6.25
} as const;
export const OCR_RUNTIME_DEFAULTS = {
  "OCR_CONTRAST_FACTOR": 1.18,
  "OCR_UPSCALE": 1,
  "OCR_SHARPEN": 1,
  "OCR_THRESHOLD": 0,
  "OCR_PSM_LINE": 7,
  "OCR_PSM_BLOCK": 6,
  "OCR_MIN_MEAN": 18,
  "OCR_MAX_MEAN": 245,
  "OCR_MIN_STDDEV": 10,
  "OCR_STRONG_CONFIDENCE_MATERIAL_NUMBER": 88,
  "OCR_STRONG_CONFIDENCE_STORAGE_ADDRESS": 84,
  "OCR_THRESHOLD_FALLBACK_BASE": 165,
  "OCR_THRESHOLD_FALLBACK_STEP": 25,
  "OCR_THRESHOLD_FALLBACK_PIVOT": 150,
  "OCR_MULTIPASS_MIN_UPSCALE": 2,
  "OCR_SEGMENTATION_PSM_LINE": 13,
  "OCR_SEGMENTATION_PSM_BLOCK": 11,
  "OCR_EXPAND_X_RATIO": 0.018,
  "OCR_EXPAND_Y_RATIO": 0.045
} as const;
export const HYBRID_RUNTIME_DEFAULTS = {
  "CNN_INPUT_SCALE": 1,
  "FAST_PATH_CONFIDENCE_THRESHOLD": 0.85
} as const;
export const DEFAULT_VISUAL_LAB_PARAMETERS_FROM_CATALOG = {
  "GRID_MASTER_SCORE": 0.6,
  "GRID_COMBINE_SCORE": 0.45,
  "MIN_ORB_INLIERS_ABSOLUTE": 6,
  "MIN_CONFIDENCE_REFINEMENT": 6,
  "MIN_CONFIDENCE_RECOVERY": 4,
  "MAX_REPROJECTION_ERROR_REFINEMENT": 2.5,
  "MAX_REPROJECTION_ERROR_RECOVERY": 4,
  "MAX_RELATIVE_CORNER_SHIFT": 0.08,
  "MIN_LABEL_AREA_RATIO": 0.1,
  "MAX_LABEL_AREA_RATIO": 0.55,
  "EXPECTED_ASPECT_RATIO": 4.35,
  "ASPECT_TOLERANCE": 0.7,
  "STRUCTURE_MIN_AREA_RATIO": 0.1,
  "STRUCTURE_MAX_AREA_RATIO": 0.55,
  "SUBPIX_WINDOW_RADIUS": 5,
  "SUBPIX_MAX_SHIFT_PX": 8,
  "SUBPIX_MIN_GRADIENT": 12,
  "HYBRID_REFERENCE_WEIGHT": 0.42,
  "HYBRID_GEOMETRY_WEIGHT": 0.23,
  "HYBRID_CNN_WEIGHT": 0.18,
  "HYBRID_OPENCV_WEIGHT": 0.12,
  "GRID_RECONSTRUCTION_MIN_HORIZONTAL_MATCHES": 3,
  "GRID_RECONSTRUCTION_MIN_VERTICAL_MATCHES": 2,
  "GRID_RECONSTRUCTION_MAX_AXIS_RESIDUAL": 0.036,
  "GRID_RECONSTRUCTION_MIN_SCORE": 0.42,
  "FINAL_SUPPORT_MIN_HORIZONTAL_LINES": 3,
  "FINAL_SUPPORT_MIN_VERTICAL_LINES": 2,
  "FINAL_SUPPORT_MIN_LINE_RATIO": 0.16,
  "FINAL_SUPPORT_NEIGHBOR_RADIUS": 2,
  "ORB_FEATURES": 2200,
  "ORB_SCALE_FACTOR": 1.2,
  "ORB_LEVELS": 8,
  "ORB_EDGE_THRESHOLD": 31,
  "ORB_PATCH_SIZE": 31,
  "ORB_FAST_THRESHOLD": 10,
  "ORB_KNN_RATIO": 0.78,
  "ORB_FALLBACK_DISTANCE_FACTOR": 0.72,
  "ORB_FALLBACK_DISTANCE_MIN": 28,
  "ORB_FALLBACK_DISTANCE_MAX": 72,
  "ORB_RANSAC_THRESHOLD": 4,
  "GRID_RANSAC_THRESHOLD": 3,
  "ORB_MIN_GOOD_MATCHES": 8,
  "ORB_GEOMETRIC_TOLERANCE_MIN": 42,
  "ORB_GEOMETRIC_TOLERANCE_FACTOR": 0.085,
  "ORB_SPATIAL_MAX_MATCHES_PER_CELL": 28,
  "ORB_SPATIAL_MAX_MATCHES_TOTAL": 260,
  "ORB_REFINEMENT_MIN_SCORE": 0.3,
  "ORB_REFINEMENT_MIN_INLIER_RATIO": 0.28,
  "ORB_MASTER_MAX_CORNER_SHIFT_RATIO": 0.055,
  "ORB_COMBINE_MAX_CORNER_SHIFT_RATIO": 0.11,
  "CLAHE_CLIP_LIMIT": 2.2,
  "CLAHE_TILE_GRID": 8,
  "HYBRID_MIN_GEOMETRY_QUALITY": 0.42,
  "HYBRID_TARGET_MIN_CONFIDENCE": 0.45,
  "HYBRID_TARGET_MAX_CORNER_DISTANCE_RATIO": 0.18,
  "HYBRID_REFERENCE_MIN_HORIZONTAL_LINES": 2,
  "HYBRID_REFERENCE_MIN_VERTICAL_LINES": 2,
  "HYBRID_REFERENCE_MIN_AVERAGE_SUPPORT": 0.12,
  "HYBRID_CANDIDATE_ACCEPT_BONUS": 0.05,
  "HYBRID_RELAXED_MIN_AREA_FLOOR": 0.055,
  "HYBRID_RELAXED_MIN_AREA_FACTOR": 0.55,
  "HYBRID_RELAXED_MAX_AREA_CEILING": 0.72,
  "HYBRID_RELAXED_MAX_AREA_FACTOR": 1.3,
  "HYBRID_RELAXED_MIN_ASPECT_RATIO": 2.65,
  "HYBRID_RELAXED_MAX_ASPECT_RATIO": 6.25,
  "OCR_CONTRAST_FACTOR": 1.18,
  "OCR_UPSCALE": 1,
  "OCR_SHARPEN": 1,
  "OCR_THRESHOLD": 0,
  "OCR_PSM_LINE": 7,
  "OCR_PSM_BLOCK": 6,
  "OCR_MIN_MEAN": 18,
  "OCR_MAX_MEAN": 245,
  "OCR_MIN_STDDEV": 10,
  "OCR_STRONG_CONFIDENCE_MATERIAL_NUMBER": 88,
  "OCR_STRONG_CONFIDENCE_STORAGE_ADDRESS": 84,
  "OCR_THRESHOLD_FALLBACK_BASE": 165,
  "OCR_THRESHOLD_FALLBACK_STEP": 25,
  "OCR_THRESHOLD_FALLBACK_PIVOT": 150,
  "OCR_MULTIPASS_MIN_UPSCALE": 2,
  "OCR_SEGMENTATION_PSM_LINE": 13,
  "OCR_SEGMENTATION_PSM_BLOCK": 11,
  "OCR_EXPAND_X_RATIO": 0.018,
  "OCR_EXPAND_Y_RATIO": 0.045
} as const;
export const DETECTION_RUNTIME_PARAMETER_KEYS = [
  "GRID_MASTER_SCORE",
  "GRID_COMBINE_SCORE",
  "MIN_ORB_INLIERS_ABSOLUTE",
  "MIN_CONFIDENCE_REFINEMENT",
  "MIN_CONFIDENCE_RECOVERY",
  "MAX_REPROJECTION_ERROR_REFINEMENT",
  "MAX_REPROJECTION_ERROR_RECOVERY",
  "MAX_RELATIVE_CORNER_SHIFT",
  "MIN_LABEL_AREA_RATIO",
  "MAX_LABEL_AREA_RATIO",
  "EXPECTED_ASPECT_RATIO",
  "ASPECT_TOLERANCE",
  "STRUCTURE_MIN_AREA_RATIO",
  "STRUCTURE_MAX_AREA_RATIO",
  "SUBPIX_WINDOW_RADIUS",
  "SUBPIX_MAX_SHIFT_PX",
  "SUBPIX_MIN_GRADIENT",
  "HYBRID_REFERENCE_WEIGHT",
  "HYBRID_GEOMETRY_WEIGHT",
  "HYBRID_CNN_WEIGHT",
  "HYBRID_OPENCV_WEIGHT",
  "GRID_RECONSTRUCTION_MIN_HORIZONTAL_MATCHES",
  "GRID_RECONSTRUCTION_MIN_VERTICAL_MATCHES",
  "GRID_RECONSTRUCTION_MAX_AXIS_RESIDUAL",
  "GRID_RECONSTRUCTION_MIN_SCORE",
  "FINAL_SUPPORT_MIN_HORIZONTAL_LINES",
  "FINAL_SUPPORT_MIN_VERTICAL_LINES",
  "FINAL_SUPPORT_MIN_LINE_RATIO",
  "FINAL_SUPPORT_NEIGHBOR_RADIUS",
  "ORB_FEATURES",
  "ORB_SCALE_FACTOR",
  "ORB_LEVELS",
  "ORB_EDGE_THRESHOLD",
  "ORB_PATCH_SIZE",
  "ORB_FAST_THRESHOLD",
  "ORB_KNN_RATIO",
  "ORB_FALLBACK_DISTANCE_FACTOR",
  "ORB_FALLBACK_DISTANCE_MIN",
  "ORB_FALLBACK_DISTANCE_MAX",
  "ORB_RANSAC_THRESHOLD",
  "GRID_RANSAC_THRESHOLD",
  "ORB_MIN_GOOD_MATCHES",
  "ORB_GEOMETRIC_TOLERANCE_MIN",
  "ORB_GEOMETRIC_TOLERANCE_FACTOR",
  "ORB_SPATIAL_MAX_MATCHES_PER_CELL",
  "ORB_SPATIAL_MAX_MATCHES_TOTAL",
  "ORB_REFINEMENT_MIN_SCORE",
  "ORB_REFINEMENT_MIN_INLIER_RATIO",
  "ORB_MASTER_MAX_CORNER_SHIFT_RATIO",
  "ORB_COMBINE_MAX_CORNER_SHIFT_RATIO",
  "CLAHE_CLIP_LIMIT",
  "CLAHE_TILE_GRID",
  "HYBRID_MIN_GEOMETRY_QUALITY",
  "HYBRID_TARGET_MIN_CONFIDENCE",
  "HYBRID_TARGET_MAX_CORNER_DISTANCE_RATIO",
  "HYBRID_REFERENCE_MIN_HORIZONTAL_LINES",
  "HYBRID_REFERENCE_MIN_VERTICAL_LINES",
  "HYBRID_REFERENCE_MIN_AVERAGE_SUPPORT",
  "HYBRID_CANDIDATE_ACCEPT_BONUS",
  "HYBRID_RELAXED_MIN_AREA_FLOOR",
  "HYBRID_RELAXED_MIN_AREA_FACTOR",
  "HYBRID_RELAXED_MAX_AREA_CEILING",
  "HYBRID_RELAXED_MAX_AREA_FACTOR",
  "HYBRID_RELAXED_MIN_ASPECT_RATIO",
  "HYBRID_RELAXED_MAX_ASPECT_RATIO"
] as const;
export type DetectionRuntimeParameterKey = typeof DETECTION_RUNTIME_PARAMETER_KEYS[number];
